import React, { Component } from 'react'
import styled from 'styled-components'

const DisclaimerStyle = styled.div`
  background-color: #EDEEF3;
  padding: 15px 20px;
  color: #3050F0;
  position: fixed;
  bottom: 0;
  z-index: 9999999;
  box-shadow: 0px -15px 20px 5px rgba(0,0,0,0.3);
  
  h3, h5 {
    display: inline-block;
  }

  h3 {
    margin-bottom: 5px;
    color: #f03059;
  }

  h5 {
    line-height: 1.5em;
  }

  button {
    color: inherit;
    margin: 0;
    padding: 0;
    margin-top: 10px;
    font-weight: 500;
    font-family: 'Roboto Mono', monospace;
    text-decoration: underline;
    background: none;
    border: none;
    cursor: pointer;
  }
`;

export default class Disclaimer extends Component {
  render() {
    const { toggleDisclaimer } = this.props;
    return (
      <DisclaimerStyle>
        <h3>ATTENZIONE - BETA STATUS</h3>
        <h5>Al momento questo applicativo si trova ancora in una fase di test e non ha ancora raggiunto lo stato di produzione. Ciò significa che <strong>si potrebbe incorrere in errori, mancata ottimizzazione per alcuni device o contenuti mancanti e/o riempitivi</strong>, ci scusiamo per il disagio. La pubblicazione della versione definitiva è fissata per il 07/10/2018</h5>
        <button onClick={toggleDisclaimer}>Chiudi avviso</button>
      </DisclaimerStyle>
    )
  }
}
